module.exports = "<div class=\"dvb-loading-button\"> <span ng-disabled=\"vm.buttonDisabled || vm.isDisabled\"> <button type=\"{{vm.type}}\" aria-label=\"{{vm.ariaLabel}}\" class=\"{{vm.buttonClass}}\" id=\"{{vm.inputId}}\" ng-click=\"vm.buttonClicked($event)\" ng-disabled=\"vm.buttonDisabled || vm.isDisabled\"> <ng-transclude></ng-transclude> </button> </span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/directive/dv-loading-button/dv-loading-button.html
// module id = 1iG2
// module chunks = 0